var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrymyaiSs2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 58.07,
    height: 43.646,
    viewBox: "0 0 58.07 43.646",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_18841",
    x: 0,
    y: 0,
    width: 58.07,
    height: 43.646,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_28623",
    "data-name": "Group 28623",
    transform: "translate(-690.891 -425.813)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 690.89, 425.81)",
    filter: "url(#Rectangle_18841)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18841-2",
    "data-name": "Rectangle 18841",
    width: 40.07,
    height: 25.646,
    rx: 5,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "presentation",
    transform: "translate(704.48 433.313)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29623",
    "data-name": "Path 29623",
    d: "M21.8,0H11.253a2.213,2.213,0,0,0-2.21,2.21V8.978L7.083,8c-.066-.033-.133-.064-.2-.094a3.34,3.34,0,1,0-4.609.2A4.452,4.452,0,0,0,0,12.006v2.26a2.214,2.214,0,0,0,1.507,2.1v3.932a.7.7,0,0,0,.7.7H6.731a.7.7,0,0,0,.7-.7v-7.9l2.252,1.126a1.93,1.93,0,0,0,2.56-.807h2.522L12.1,20.054a.7.7,0,0,0,1.322.481l2.846-7.825h.493l2.875,7.828a.7.7,0,0,0,1.321-.485l-2.7-7.343H21.8a2.21,2.21,0,0,0,2.21-2.21V2.21A2.21,2.21,0,0,0,21.8,0ZM2.537,5.6A1.934,1.934,0,1,1,4.471,7.535,1.936,1.936,0,0,1,2.537,5.6Zm8.507,6.356-.005.016a.52.52,0,0,1-.723.285L7.046,10.623a.7.7,0,0,0-1.018.629v8.339H2.914V15.773a.7.7,0,0,0-.7-.7.8.8,0,0,1-.8-.8v-2.26A3.065,3.065,0,0,1,4.471,8.942h.622a3.065,3.065,0,0,1,1.363.321l4.378,2.178A.422.422,0,0,1,11.045,11.957ZM22.605,10.5a.8.8,0,0,1-.235.568.809.809,0,0,1-.568.235H12.4l0-.011L14.142,7.8a.7.7,0,0,0-1.258-.629l-1.489,2.978-.946-.471V2.21a.8.8,0,0,1,.8-.8H21.8a.808.808,0,0,1,.569.236.8.8,0,0,1,.235.568Zm0,0",
    fill: "#002140"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29624",
    "data-name": "Path 29624",
    d: "M264.459,64.266H257.7a.631.631,0,0,0,0,1.262h6.761a.631.631,0,0,0,0-1.262Zm0,0",
    transform: "translate(-243.782 -61.561)",
    fill: "#002140"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29625",
    "data-name": "Path 29625",
    d: "M341.41,120.5H338.03a.631.631,0,0,0,0,1.262h3.381a.631.631,0,0,0,0-1.262Zm0,0",
    transform: "translate(-320.734 -114.807)",
    fill: "#002140"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29626",
    "data-name": "Path 29626",
    d: "M341.41,176.734H338.03a.631.631,0,0,0,0,1.262h3.381a.631.631,0,0,0,0-1.262Zm0,0",
    transform: "translate(-320.734 -168.385)",
    fill: "#002140"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28622",
    "data-name": "Group 28622",
    transform: "translate(126.52 -38.187)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12391",
    "data-name": "Group 12391",
    transform: "translate(595 466)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1000",
    "data-name": "Ellipse 1000",
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#ea555f"
  }), /*#__PURE__*/React.createElement("text", {
    id: "_5",
    "data-name": 5,
    transform: "translate(8 12)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -3,
    y: 0
  }, "5")))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrymyaiSs2);
export default __webpack_public_path__ + "static/media/trymyai-ss-2.786623b563f6eca5c6b23f3fb4c2e454.svg";
export { ForwardRef as ReactComponent };